import { FormattedMessage } from "react-intl";

import { Tag } from "antd";

export const CmtBenchField = () => (
  <Tag color="gold">
    <FormattedMessage id="table.on_bench" defaultMessage="On bench" />
  </Tag>
);
